import React from 'react';
import T from 'prop-types';
import { Switch, colors } from '@acast/decibel';
import { LockLightGlyph } from '@acast/decibel-glyphs';
import Card from './card';
import CardIcon from './card-icon';

const LockedEpisodeCard = ({ disabled, locked, handleChange }) => (
  <Card disabled={disabled}>
    <Card.Header
      title="Locked episode"
      action={
        <Switch
          disabled={disabled}
          checked={locked}
          onChange={e => {
            handleChange(e.target.checked);
          }}
        />
      }
      media={<CardIcon background={colors.red16} foreground={colors.red} glyph={LockLightGlyph} />}
    />
    <Card.Content>Locked episodes are only available to Access subscribers.</Card.Content>
  </Card>
);

LockedEpisodeCard.propTypes = {
  disabled: T.bool,
  locked: T.bool,
  handleChange: T.func.isRequired,
};

LockedEpisodeCard.defaultProps = {
  disabled: false,
  locked: false,
};

export default LockedEpisodeCard;
